<template>
	<div class="mtm-spinner"><div class="icon"></div></div>
</template>

<script>
	export default {
		name: "spinner"
	};
</script>

<style lang="scss" scoped>
	.mtm-spinner  {
		text-align: center;
		.icon{
			background: url('/wp-content/themes/esmark_meltdown/gfx/preloader.gif') no-repeat center center;
			background-size: cover;
			width: 30px;
			height: 30px;
			display: inline-block;
		}
	}

</style>
